import styled from "@emotion/styled";
import { Box } from "@kaltura/mediaspace-shared-styled";

export const StyledListItemContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    alignItems: "flex-end",
    gap: theme.spacing(1),
    padding: theme.spacing(1, 2),
}));
